
// //

// // src/components/Materias/AgregarMateria.jsx
// import React, { useState, useEffect } from "react";
// import axios from "../../api/axiosAuth";

// import { useAuth } from "../../context/AuthContext";
// import "../../style/AsignarMateria.css";
// const API = process.env.REACT_APP_API_BASE || "http://3.236.217.225:5001/api";

// function AgregarMateria() {
//   const { user, token } = useAuth(); // ⬅️ Aquí vienen tenant_id y sede_id
//   const [nombreMateria, setNombreMateria] = useState("");
//   const [mensaje, setMensaje] = useState("");
//   const [materias, setMaterias] = useState([]);

//   const headers = {
//     Authorization: `Bearer ${token}`,
//     "x-tenant-id": user?.tenant_id,
//     "x-sede-id": user?.sede_id,
//   };

//   // ==========================================================
//   // 🔹 Cargar materias multitenant (solo del tenant + sede)
//   // ==========================================================
//   const cargarMaterias = async () => {
//     try {
//       const res = await axios.get(`${API}/materias`, { headers });
//       setMaterias(res.data);
//     } catch (error) {
//       console.error("Error al cargar materias:", error);
//       setMensaje("Error al cargar materias.");
//     }
//   };

//   useEffect(() => {
//     if (token && user) cargarMaterias();
//   }, [token, user]);

//   // ==========================================================
//   // 🔹 Guardar materia (con tenant_id + sede_id)
//   // ==========================================================
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!nombreMateria.trim()) {
//       setMensaje("Por favor ingresa un nombre válido.");
//       return;
//     }

//     try {
//       const res = await axios.post(
//         `${API}/materias`,
//         {
//           nombre: nombreMateria.trim(),
//           tenant_id: user.tenant_id, // ⬅️ obligatorio
//           sede_id: user.sede_id, // ⬅️ obligatorio
//         },
//         { headers }
//       );

//       setMensaje(res.data.message);
//       setNombreMateria("");
//       cargarMaterias();
//     } catch (error) {
//       console.error("Error al guardar materia:", error);
//       setMensaje(error?.response?.data?.message || "Error al guardar materia.");
//     }
//   };

//   // ==========================================================
//   // 🔹 Eliminar materia multitenant
//   // ==========================================================
//   const eliminarMateria = async (id) => {
//     if (!window.confirm("¿Seguro que deseas eliminar esta materia?")) return;

//     try {
//       const res = await axios.delete(`${API}/materias/${id}`, {
//         headers,
//       });
//       setMensaje(res.data.message);
//       cargarMaterias();
//     } catch (error) {
//       console.error("Error al eliminar materia:", error);
//       setMensaje("Error al eliminar materia.");
//     }
//   };

//   // ==========================================================
//   // 🔹 Renderizado
//   // ==========================================================
//   return (
//     <div className="agregar-materia-card">
//       <h2>Agregar Materia</h2>

//       <form onSubmit={handleSubmit} className="form-agregar-materia">
//         <input
//           type="text"
//           placeholder="Nombre de la materia"
//           value={nombreMateria}
//           onChange={(e) => setNombreMateria(e.target.value)}
//           className="input-materia"
//         />
//         <button type="submit" className="btn-guardar">
//           Guardar
//         </button>
//       </form>

//       {mensaje && <p className="mensaje">{mensaje}</p>}

//       <h3>Materias Registradas</h3>

//       {materias.length === 0 ? (
//         <p>No hay materias registradas aún.</p>
//       ) : (
//         <div className="tabla-container">
//           <table className="tabla-materias">
//             <thead>
//               <tr>
//                 <th>ID</th>
//                 <th>Nombre</th>
//                 <th>Acciones</th>
//               </tr>
//             </thead>

//             <tbody>
//               {materias.map((materia) => (
//                 <tr key={materia.id}>
//                   <td>{materia.id}</td>
//                   <td>{materia.nombre}</td>
//                   <td>
//                     <button
//                       className="btn-eliminar"
//                       onClick={() => eliminarMateria(materia.id)}
//                     >
//                       Eliminar
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// }

// export default AgregarMateria;


//

import React, { useState, useEffect, useCallback, useMemo } from "react";
import axios from "../../api/axiosAuth";
import { useAuth } from "../../context/AuthContext";
import "../../style/AsignarMateria.css";

function AgregarMateria() {
  const { user, token } = useAuth(); 
  const [nombreMateria, setNombreMateria] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [materias, setMaterias] = useState([]);
  const [loading, setLoading] = useState(false);

  // ✅ Memorizamos los headers para que no cambien en cada renderizado
  const headers = useMemo(() => ({
    Authorization: `Bearer ${token}`,
    "x-tenant-id": user?.tenant_id,
    "x-sede-id": user?.sede_id,
  }), [token, user]);

  /* =========================================
      🔄 CARGAR MATERIAS (READ)
  ========================================= */
  const cargarMaterias = useCallback(async () => {
    if (!token || !user?.tenant_id) return;
    
    try {
      setLoading(true);
      // Usamos la ruta relativa de la instancia axiosAuth
      const res = await axios.get("/materias", { headers });
      setMaterias(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      console.error("❌ Error al cargar materias:", error);
      setMensaje("Error: No se pudieron cargar las materias.");
    } finally {
      setLoading(false);
    }
  }, [headers, token, user?.tenant_id]);

  useEffect(() => {
    cargarMaterias();
  }, [cargarMaterias]);

  /* =========================================
      💾 GUARDAR MATERIA (CREATE)
  ========================================= */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensaje("");

    if (!nombreMateria.trim()) {
      setMensaje("⚠️ Por favor ingresa un nombre válido.");
      return;
    }

    try {
      setLoading(true);
      await axios.post(
        "/materias",
        {
          nombre: nombreMateria.trim(),
          tenant_id: user.tenant_id, // Doble validación: en body y headers
          sede_id: user.sede_id,
        },
        { headers }
      );

      setMensaje("✅ Materia guardada correctamente");
      setNombreMateria("");
      cargarMaterias(); 
      
      setTimeout(() => setMensaje(""), 4000);
    } catch (error) {
      console.error("❌ Error al guardar materia:", error);
      setMensaje(error?.response?.data?.msg || "Error al intentar guardar la materia.");
    } finally {
      setLoading(false);
    }
  };

  /* =========================================
      🗑️ ELIMINAR MATERIA (DELETE)
  ========================================= */
  const eliminarMateria = async (id) => {
    if (!window.confirm("¿Seguro que deseas eliminar esta materia? Esta acción no se puede deshacer.")) return;

    try {
      await axios.delete(`/materias/${id}`, { headers });
      setMensaje("🗑️ Materia eliminada con éxito.");
      cargarMaterias();
      
      setTimeout(() => setMensaje(""), 4000);
    } catch (error) {
      console.error("❌ Error al eliminar materia:", error);
      setMensaje("No se pudo eliminar la materia seleccionada.");
    }
  };

  return (
    <div className="agregar-materia-card">
      <header className="materia-header">
        <h2>📚 Gestión de Materias</h2>
        <p className="subtitle">
          Configuración activa para: <strong>{user?.sede_nombre || "Sede Principal"}</strong>
        </p>
      </header>

      <div className="materia-content">
        <form onSubmit={handleSubmit} className="form-agregar-materia">
          <div className="input-group">
            <label htmlFor="materia-input">Nombre de la Nueva Materia</label>
            <div className="input-with-button">
              <input
                id="materia-input"
                type="text"
                placeholder="Ej: Matemáticas, Física, Química..."
                value={nombreMateria}
                onChange={(e) => setNombreMateria(e.target.value)}
                className="input-materia"
                disabled={loading}
                required
              />
              <button type="submit" className="btn-guardar" disabled={loading}>
                {loading ? "..." : "Guardar"}
              </button>
            </div>
          </div>
        </form>

        {mensaje && (
          <div className={`mensaje-toast ${mensaje.includes("Error") || mensaje.includes("⚠️") ? "error" : "success"}`}>
            {mensaje}
          </div>
        )}

        <div className="listado-seccion">
          <h3>Materias Registradas</h3>
          {loading && materias.length === 0 ? (
            <div className="loading-state">⏳ Cargando listado...</div>
          ) : materias.length === 0 ? (
            <div className="no-data">
              <p>No hay materias registradas en esta sede.</p>
            </div>
          ) : (
            <div className="tabla-container">
              <table className="tabla-materias">
                <thead>
                  <tr>
                    <th>Ref</th>
                    <th>Nombre de la Materia</th>
                    <th style={{ textAlign: "center" }}>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {materias.map((materia) => (
                    <tr key={materia.id}>
                      <td className="col-id">#{materia.id}</td>
                      <td className="col-nombre"><strong>{materia.nombre}</strong></td>
                      <td className="col-acciones">
                        <button
                          className="btn-eliminar-icon"
                          onClick={() => eliminarMateria(materia.id)}
                          title="Eliminar materia"
                        >
                          Eliminar
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AgregarMateria;